export const handleChange = (setData: (data: Object) => any) =>  (data: {value: any, id: string}) => {
    setData({[data.id]: data.value});
};